import React, { useCallback, useState, memo } from 'react';
import { Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import { connect } from "react-redux";
import {DEFAULT_RESOLUTION} from '../constants.js';
import {
    getXPositionFromStep,
    getYPositionFromVolume
} from './positionUtils.js';

const VolumeAutomationPoint = memo(({
    onMouseDown,
    highlightPoint,
    unhighlightPoint,
    onMouseUp,
    step,
    resolution,
    xScale,
    volume,
    isHighlighted}) => {
    return (
        <circle
          onMouseDown={onMouseDown}
          onMouseOver={highlightPoint}
          onMouseLeave={unhighlightPoint}
          onMouseUp={onMouseUp}
          cx={getXPositionFromStep(step, resolution, xScale)}
          cy={getYPositionFromVolume(volume)}
          r={2}
          fill={isHighlighted ? 'blue' : 'black'}
          stroke={isHighlighted ? 'blue' : 'red'}
          strokeWidth={2} />
    );
    });

const mapStateToProps = (state, props) => {
    return {
        step: props.event.step,
        volume: props.event.volume,
        resolution: DEFAULT_RESOLUTION,
        xScale: state.arrangement.xScale
    };
};
 
export default connect(mapStateToProps, null)(VolumeAutomationPoint);
